import { Grid, GridProps, styled } from '@mui/material'
import { ReactNode } from 'react'
import CFDAdvertising from 'views/CustomerFacingDisplay/components/CFDAdvertising'

const GridItem = styled((props: GridProps) => (
    <Grid item container xs={6} {...props} />
))(() => ({
    height: '100svh',
    padding: 4,
}))

function CustomerFacingDisplayLayout({ children }: { children: ReactNode }) {
    return (
        <main>
            <Grid
                container
                height={'100vh'}
                width={'100vw'}
                overflow={'hidden'}
            >
                <GridItem>
                    <CFDAdvertising />
                </GridItem>

                <GridItem>{children}</GridItem>
            </Grid>
        </main>
    )
}

export default CustomerFacingDisplayLayout
